import useLoadingText from '../../hooks/useLoadingText';
import useThread from '../../hooks/useThread';
import { parseItemID } from '../../utils/parse';
import styles from './item.module.scss';
import { classnames } from '@/utils/functions';
import useSession from '@/hooks/useSession';
import FeedbackCTA from '@/components/FeedbackCTA';
import BaseMessage from '../Message/BaseMessage';
import Response from '../Message/Response';
import useItem from '../../hooks/useItem';

const Item = () => {
  const { status, processingStatus } = useThread();
  const { item, isLast } = useItem();
  const { id, disliked, prompt, queryDate, response } = item;
  const { session } = useSession();
  const { remainingThisMonth, perMonth } = session.promptUsage;
  const loadingText = useLoadingText(status, id || '');
  const isLoading =
    response.length === 0 && status === 'FETCHING' && loadingText;

  return (
    <div
      data-testid="thread-item"
      className={classnames(styles['item'], {
        [styles['disliked']]: disliked,
      })}
      id={parseItemID(id)}
      data-loading={!!(isLast && (status == 'TYPING' || isLoading))}
    >
      <span data-testid="item-date" className={styles['item-date']}>
        {queryDate.toLocaleString()}
      </span>
      <BaseMessage author="USER">{prompt}</BaseMessage>
      {isLast && status === 'ERROR' ? (
        <div data-testid={`item-error`} className={styles['error-banner']}>
          {remainingThisMonth <= 0 ? (
            <>
              <h3>Thank you for using GANNET 🚀</h3>
              <p>
                You ran out of prompts for the current month. You have to wait
                until next month to get {perMonth} fresh prompts to keep using
                GANNET.
              </p>

              <p>
                It would really help us if you could spare 5 minutes of your
                time to fill out a short survey.
              </p>
              <p>
                <FeedbackCTA
                  useLink={true}
                  text="Click here to fill out our feedback survey"
                />
              </p>
            </>
          ) : (
            <>
              {typeof processingStatus !== 'undefined' ? (
                <p>
                  An error happened while getting the response. Try to reload
                  the page or check your internet connection. If the problem
                  persists.
                </p>
              ) : (
                <p>Sorry, I am unable to process your request at the moment.</p>
              )}
            </>
          )}
        </div>
      ) : !isLoading ? (
        <>
          <BaseMessage author="ASSISTANT">
            <Response />
          </BaseMessage>
        </>
      ) : (
        <BaseMessage author="ASSISTANT">{loadingText}</BaseMessage>
      )}
    </div>
  );
};

export default Item;
